import React, { FC, SVGProps } from 'react';

export const Lifestyle: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#BAE1D1" />
    <line
      x1="39.5723"
      y1="15.2857"
      x2="39.5723"
      y2="64.7143"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="15.2861"
      y1="40.4286"
      x2="64.7147"
      y2="40.4286"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="24.2861"
      y1="55.7286"
      x2="55.7291"
      y2="24.2857"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="24.2716"
      y1="24.2857"
      x2="55.7146"
      y2="55.7286"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <ellipse
      cx="40.0006"
      cy="40"
      rx="14.4"
      ry="14.4"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
